import React, { useState, useImperativeHandle, forwardRef } from 'react'

//images
import closeIcon from '../../assets/images/theory/close.png'

function Gallery(props, ref) {

    const [gallery, setGallery] = useState({
        overlay: false,
        url: '',
    })

    useImperativeHandle(ref, () => ({
        show: url => {
            setGallery(gallery => ({
                ...gallery,
                overlay: true,
                url: url,
            }))
        },
        hide: () => {
            handleHide()
        }
    }));

    const handleHide = () => {
        setGallery(gallery => ({
            ...gallery,
            overlay: false,
            url: '',
        }))
    }


    return (
        <div id="overlay" className={`${props.advanced ? 'advanced' : ''} ${gallery.overlay ? 'visible' : ''}`}>
            <img src={closeIcon} alt="close" className="close-gallery" onClick={handleHide} />
            <img
                src={gallery.url}
                alt="image"
                className="main-img"
            />
        </div>
    )
}

export default forwardRef(Gallery)